import { Node, mergeAttributes } from '@tiptap/core';

export const ScriptureBlock = Node.create({
  name: 'scriptureBlock',

  group: 'block',

  content: 'inline*',

  atom: true,

  addAttributes() {
    return {
      reference: {
        default: '',
      },
      version: {
        default: 'NIV',
      },
      text: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="scripture-block"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'scripture-block',
        class: 'scripture-block',
        contenteditable: 'false',
      }),
      [
        'div',
        {
          class: 'scripture-header',
          style: 'display: flex; justify-content: space-between; align-items: center;',
        },
        [
          'div',
          { class: 'scripture-reference' },
          `${HTMLAttributes.reference} (${HTMLAttributes.version})`,
        ],
        [
          'button',
          {
            class: 'edit-scripture-btn',
            type: 'button',
            'data-reference': HTMLAttributes.reference,
            'data-version': HTMLAttributes.version,
            'data-text': HTMLAttributes.text,
          },
          'Edit',
        ],
      ],
      ['div', { class: 'scripture-text' }, HTMLAttributes.text],
    ];
  },

  addCommands() {
    return {
      setScriptureBlock:
        (attributes) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
      updateScriptureBlock:
        (attributes) =>
        ({ commands }) => {
          return commands.updateAttributes(this.name, attributes);
        },
    };
  },
});

export default ScriptureBlock;
